//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Curve.js";
import "../no/ugmath.js";
let d=[[[0,"CenterPoint",0,0],[0,"Matrix",0,"NXMatrix",0],[0,"RotationAngle",0,0]],[[["center","x_direction","y_direction"],"GetOrientation",{},0,0],[["center","x_direction","y_direction"],"SetOrientation",{},3,0],[["startPoint","endPoint","anchorPoint","rho"],"SetParameters",{},4,0]],[]];
SPLM.Conic = class extends SPLM.Curve{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Conic";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;